import { render, staticRenderFns } from "./CreateAssessmentQuestion.vue?vue&type=template&id=329f60a6&scoped=true&"
import script from "./CreateAssessmentQuestion.vue?vue&type=script&lang=js&"
export * from "./CreateAssessmentQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CreateAssessmentQuestion.vue?vue&type=style&index=0&id=329f60a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329f60a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VLazy,VRow,VSelect,VTextField,VTextarea})
